export interface FunnelEntry {
  id: string;
  title: string;
  description: string;
  features: string[];
  href: string;
  badge?: string;
}

export const funnels: FunnelEntry[] = [
  {
    id: "BPC-157",
    title: "BPC-157 Recovery Journey",
    description: "A guided intake prototype for orthopedic and GI recovery pathways.",
    features: [
      "Outcome-oriented intake",
      "Orthopedic and GI branching",
      "Interactive anatomical selection",
      "Recovery baseline and portal continuity",
    ],
    href: "/funnels/BPC-157",
    badge: "Prototype",
  },
];
